import { User } from '../../types/User';
import { UserFilters } from '../../types/UserFilters';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';
import { useFetchWithCursorPagination } from '../base/useFetchWithCursorPagination';
import { mapUserDtoResponseToUser, UserDto } from '../dtos/UserDto';

export const useGetUsersOfResource = (
    resourceId: string,
    filters: UserFilters,
    sorting: { direction: 'asc' | 'desc'; field: string }
) => {
    const { data, fetchNextPage, loading, refresh } = useFetchWithCursorPagination<UserDto, User, UserFilters>({
        filters,
        mapResponse: mapUserDtoResponseToUser,
        sorting,
        url: `${ACCESS_ANALYSIS_BASE_URL}/resources/${resourceId}/users`
    });

    return {
        fetchMoreUsers: fetchNextPage,
        refetchUsers: refresh,
        users: data,
        usersLoading: loading
    };
};
